import { forwardRef } from "react";
import BadgeCheck from "lucide-react/dist/esm/icons/badge-check";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SellerBadgeProps {
  verified?: boolean;
  size?: "sm" | "md" | "lg";
  showTooltip?: boolean;
  className?: string;
}

export const SellerBadge = forwardRef<HTMLSpanElement, SellerBadgeProps>(
  ({ verified = false, size = "sm", showTooltip = true, className }, ref) => {
    const sizeClasses = {
      sm: "h-3.5 w-3.5",
      md: "h-4 w-4",
      lg: "h-5 w-5",
    };

    const badge = (
      <BadgeCheck
        className={cn(
          sizeClasses[size],
          verified ? "text-primary fill-primary/20" : "text-muted-foreground fill-muted",
          className
        )}
      />
    );

    if (!showTooltip) {
      return <span ref={ref} className="inline-flex">{badge}</span>;
    }

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span ref={ref} className="inline-flex">{badge}</span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{verified ? "Verified Seller" : "Seller"}</p>
        </TooltipContent>
      </Tooltip>
    );
  }
);

SellerBadge.displayName = "SellerBadge";
